import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { PaginationFilters, PaginationResponse } from "../../types/Pagination";
import { VehicleSettlementSurveyResponse } from "../../types/Survey";

export type VehicleSettlementSurveyResponsePaginationFilters =
  PaginationFilters & {
    firstResponseId?: string;
  };

export const getMyEmployerVehicleSettlementSurveyResponses = (
  filters: VehicleSettlementSurveyResponsePaginationFilters,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();
  const { nextPageLink, pageSize } = filters;

  return useQuery({
    queryKey: ["employerVehicleSettlementSurveyResponses", filters],
    queryFn: (): Promise<
      PaginationResponse<VehicleSettlementSurveyResponse>
    > => {
      return fetchWithAuth<PaginationResponse<VehicleSettlementSurveyResponse>>(
        "getMyEmployerVehicleSettlementSurveyResponses",
        undefined,
        {
          queryParams: {
            ...filters,
            nextPage: nextPageLink ?? undefined,
            pageSize: pageSize ? `${pageSize}` : undefined,
          },
        }
      );
    },
    enabled: isQueryEnabled(options),
    keepPreviousData: options.keepPreviousData,
  });
};
